export function formatUserName(name: string, surname: string): string {
    // Converti name e surname in lower case
    const lowerName = name.toLowerCase();
    const lowerSurname = surname.toLowerCase();

    // Formatta il nome con l'iniziale maiuscola
    const formattedName = lowerName.charAt(0).toUpperCase() + lowerName.slice(1);

    // Gestione del cognome per i casi con uno o più cognomi
    const formattedSurname = lowerSurname
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

    // Ritorna la stringa formattata
    return `${formattedName} ${formattedSurname}`;
}